export type CategoriaArbitralTemplate =
  | 'CERTIDAO_CITACAO'
  | 'CERTIDAO_ACESSO'
  | 'CERTIDAO_TRIAGEM'
  | 'CERTIDAO_DECURSO'
  | 'CERTIDAO_NOMEACAO'
  | 'CERTIDAO_TRANSITO_JULGADO'
  | 'TERMO_IMPARCIALIDADE'
  | 'TERMO_ARBITRAGEM'
  | 'INTIMACAO_CITACAO'
  | 'INTIMACAO_SENTENCA'
  | 'INTIMACAO_DOCUMENTACAO'
  | 'INTIMACAO_BAIXA'
  | 'OFICIO_REQUISITORIO'
  | 'BOLETO_GERADO';

/**
 * Categorias aceitas pelo motor em `gerarCertidaoExecutor` e `envio/envioResolvers`.
 * Atas foi validada apenas para cadastro: fica fora desta lista até a definição do motor.
 * Boleto permanece para que a edição de fluxos históricos conserve a seleção existente.
 * Os rótulos comuns ao cadastro precisam acompanhar `CATEGORIA_MODELO_LABEL`.
 */
export const CATEGORIA_ARBITRAL_TEMPLATE_OPTIONS: Array<{
  value: CategoriaArbitralTemplate;
  label: string;
}> = [
  { value: 'CERTIDAO_CITACAO', label: 'Certidão de citação' },
  { value: 'CERTIDAO_ACESSO', label: 'Certidão de acesso' },
  { value: 'CERTIDAO_TRIAGEM', label: 'Certidão de triagem' },
  { value: 'CERTIDAO_DECURSO', label: 'Certidão de decurso' },
  { value: 'CERTIDAO_NOMEACAO', label: 'Certidão de nomeação' },
  { value: 'CERTIDAO_TRANSITO_JULGADO', label: 'Certidão de trânsito' },
  { value: 'TERMO_IMPARCIALIDADE', label: 'Termo de imparcialidade' },
  { value: 'TERMO_ARBITRAGEM', label: 'Termos' },
  { value: 'INTIMACAO_CITACAO', label: 'Intimação de citação' },
  { value: 'INTIMACAO_SENTENCA', label: 'Intimação de sentença' },
  { value: 'INTIMACAO_DOCUMENTACAO', label: 'Intimação de documentação' },
  { value: 'INTIMACAO_BAIXA', label: 'Intimação de baixa' },
  { value: 'OFICIO_REQUISITORIO', label: 'Ofícios' },
  { value: 'BOLETO_GERADO', label: 'Boleto gerado' },
];

/**
 * Rótulo por categoria, derivado das options — mesma fonte, sem uma segunda tabela para
 * divergir. Quem precisa de lookup por chave (o badge da aba Certificados) usa isto; quem
 * precisa da ordem de exibição (o `select` do editor) usa o array.
 */
export const CATEGORIA_ARBITRAL_TEMPLATE_LABEL = Object.fromEntries(
  CATEGORIA_ARBITRAL_TEMPLATE_OPTIONS.map(({ value, label }) => [value, label]),
) as Record<CategoriaArbitralTemplate, string>;

/**
 * A categoria vem do back e chega ao front por cast cru no DTO de certificados
 * (`arbitral-detalhes/store/certificados/services.ts`), então valor fora do enum é possível —
 * `SENTENCA` e `DESPACHO_DECISAO` existem no backend e não estão aqui. Sem esta checagem, um
 * `if (categoria)` trata qualquer string truthy como categoria conhecida e desliga o caminho
 * de fallback de quem depende dela (achado COR-01 do review do PR #986).
 */
export function isCategoriaArbitralTemplate(
  valor: string | null | undefined,
): valor is CategoriaArbitralTemplate {
  return (
    valor !== null &&
    valor !== undefined &&
    Object.prototype.hasOwnProperty.call(CATEGORIA_ARBITRAL_TEMPLATE_LABEL, valor)
  );
}
